import React, { useRef, useState } from "react";
import Editor from "@monaco-editor/react";

const MonacoEditor = ({
  height = "290px",
  initialLanguage = "cpp",
  value = "",
  onChange,
}) => {
  const editorRef = useRef(null);
  const [language, setLanguage] = useState(initialLanguage);

  const languages = [
    { label: "C++", value: "cpp" },
    { label: "C", value: "c" },
    { label: "Python", value: "python" },
    { label: "Java", value: "java" },
  ];

  const editorDefaultValue = {
    cpp: "// Type or Paste your Code Here",
    c: "// Type or Paste your Code Here",
    java: "// Type or Paste your Code Here",
    python: "# Type or Paste your Code Here"
  };


  function handleEditorDidMount(editor) {
    editorRef.current = editor;
  }

  function handleChange(value) {
    onChange?.(value);
  }

  function handleLanguageChange(e) {
    setLanguage(e.target.value);
  }

  return (
    <div
      style={{
        border: "1px solid #ccc",
        borderRadius: "6px",
        overflow: "hidden",
        background: "#1e1e1e",
      }}
    >
      {/* Toolbar */}
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          padding: "6px 10px",
          background: "#ffffff",
          borderBottom: "1px solid #444",
        }}
      >
        {/* <text>Select Language: &emsp;</text> */}
        <select
          value={language}
          onChange={handleLanguageChange}
          style={{
            padding: "4px 8px",
            fontSize: "14px",
            borderRadius: "4px",
            border: "1px solid #888",
            background: "#ffffff",
            color: "#000000",
          }}
        >
          {languages.map((lang) => (
            <option key={lang.value} value={lang.value}>
              {lang.label}
            </option>
          ))}
        </select>
      </div>

      {/* Monaco Editor */}
      <Editor
        height={height}
        language={language}
        value={value || editorDefaultValue[language]}
        theme="vs-light"
        onChange={(val) => {
          handleChange(val)
          if (!val.trim()) val = editorDefaultValue[language]
        }}
        onMount={handleEditorDidMount}
        options={{
          minimap: { enabled: false },
          fontSize: 14,
          automaticLayout: true,
        }}
      />
    </div>
  );
};

export default MonacoEditor;
